import client from "./client";
import type {
  DeletionStatus,
  DepartmentFull,
  Organization,
} from "@/types/organization";

export async function getCurrentOrg(): Promise<Organization> {
  const res = await client.get<Organization>("/organizations/current");
  return res.data;
}

export async function updateOrg(
  data: Partial<Organization>
): Promise<Organization> {
  const res = await client.put<Organization>("/organizations/current", data);
  return res.data;
}

export async function listDepartments(): Promise<DepartmentFull[]> {
  const res = await client.get<DepartmentFull[]>("/organizations/departments");
  return res.data;
}

export async function createDepartment(data: {
  name: string;
  code?: string;
  description?: string;
}): Promise<DepartmentFull> {
  const res = await client.post<DepartmentFull>(
    "/organizations/departments",
    data
  );
  return res.data;
}

export async function updateDepartment(
  id: string,
  data: Partial<DepartmentFull>
): Promise<DepartmentFull> {
  const res = await client.put<DepartmentFull>(
    `/organizations/departments/${id}`,
    data
  );
  return res.data;
}

/**
 * Schedule the current organization for permanent deletion after a 30-day
 * grace period. The SUPER_ADMIN must re-type the org's exact name as
 * ``confirmationName`` — enforced server-side — mirroring GitHub's repo
 * delete flow.
 */
export async function requestOrgDeletion(
  confirmationName: string,
): Promise<DeletionStatus> {
  const res = await client.post<DeletionStatus>(
    "/organizations/current/deletion",
    { confirmation_name: confirmationName },
  );
  return res.data;
}

export async function getOrgDeletionStatus(): Promise<DeletionStatus> {
  const res = await client.get<DeletionStatus>(
    "/organizations/current/deletion",
  );
  return res.data;
}
